module.exports = __webpack_public_path__ + "static/salon-de-pasajeros---acabado-techo-ae1d9a775aaf854af4d5458425263e79.jpg";